import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';
let NgDocSpinnerComponent = /*#__PURE__*/(() => {
  class NgDocSpinnerComponent {
    constructor() {
      this.size = 'medium';
    }
    static {
      this.ɵfac = function NgDocSpinnerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocSpinnerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocSpinnerComponent,
        selectors: [["ng-doc-spinner"]],
        hostVars: 1,
        hostBindings: function NgDocSpinnerComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("data-ng-doc-size", ctx.size);
          }
        },
        inputs: {
          size: "size"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 0,
        consts: [["viewBox", "0 0 50 50", 1, "ng-doc-spinner"], ["cx", "25", "cy", "25", "r", "20", "fill", "none", "stroke-width", "5", 1, "ng-doc-spinner-path"]],
        template: function NgDocSpinnerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(0, "svg", 0);
            i0.ɵɵelement(1, "circle", 1);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{display:inline-block}[data-ng-doc-size=small][_nghost-%COMP%]{width:calc(var(--ng-doc-base-gutter) * 3);height:calc(var(--ng-doc-base-gutter) * 3)}[data-ng-doc-size=medium][_nghost-%COMP%]{width:calc(var(--ng-doc-base-gutter) * 5);height:calc(var(--ng-doc-base-gutter) * 5)}[data-ng-doc-size=large][_nghost-%COMP%]{width:calc(var(--ng-doc-base-gutter) * 8);height:calc(var(--ng-doc-base-gutter) * 8)}[_nghost-%COMP%]   .ng-doc-spinner[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_rotate 2s linear infinite}[_nghost-%COMP%]   .ng-doc-spinner[_ngcontent-%COMP%]   .ng-doc-spinner-path[_ngcontent-%COMP%]{stroke:var(--ng-doc-spinner-color, var(--ng-doc-primary));stroke-linecap:round;animation:_ngcontent-%COMP%_dash 1.5s ease-in-out infinite}@keyframes _ngcontent-%COMP%_rotate{to{transform:rotate(360deg)}}@keyframes _ngcontent-%COMP%_dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}to{stroke-dasharray:90,150;stroke-dashoffset:-124}}"],
        changeDetection: 0
      });
    }
  }
  return NgDocSpinnerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocSpinnerComponent };
